import { render, staticRenderFns } from "./census.vue?vue&type=template&id=4d8032ba&scoped=true"
import script from "./census.vue?vue&type=script&lang=js"
export * from "./census.vue?vue&type=script&lang=js"
import style0 from "./census.vue?vue&type=style&index=0&id=4d8032ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8032ba",
  null
  
)

export default component.exports